import type { TelegramMessage } from "@/types/telegram";

export function formatTelegramMarkdown(message: TelegramMessage): string {
  const lines = [
    `# Telegram: ${message.subject}`,
    "",
    `- **From:** ${message.from}`,
    message.to ? `- **To:** ${message.to}` : null,
    `- **Date:** ${message.date}`,
    `- **Chat ID:** ${message.chatId}`,
    "",
    message.body || message.preview,
  ].filter(Boolean);
  return lines.join("\n");
}

export function telegramMetadata(message: TelegramMessage): Record<string, unknown> {
  return {
    source: "telegram",
    chatId: message.chatId,
    messageId: message.id,
    from: message.from,
    date: message.date,
  };
}
